import { AssignmentContract } from './assignmentContract.model';

export const assignmentContractMock = new AssignmentContract(undefined);
